module.exports = __webpack_public_path__ + "52c9540dd8171b2a26304163a1e14155.pdf";